import productCategories from '../content/products/categories.json'

export default function useProductCategories() {
    return productCategories
}
